{ "name": "day", "sunDir": [-0.45, 0.78, 0.43], "sunColor": "#FFF6E0", "sunIntensity": 2.6,
  "skyColor": "#BFD6F2", "groundColor": "#8A8478", "hemiIntensity": 1.15,
  "hazeAmount": 0.10, "tint": "#FFFFFF", "tintAmount": 0.0, "valueScale": 1.0 }
